export interface GridRow {
  compositionPath: string[];
  description: string;
  order: string;
  exclVatTotal: number | null;
  // Backend-computed group flag, read directly by AG Grid's `isServerSideGroup`.
  hasChildren: boolean;
  hidden: boolean;
  id: string;
  inclVatTotal: number | null;
  index: number;
  parentId: string | null;
  quantity: number | null;
  rowType: number;
  unit: number | null;
  unitCostPrice: number | null;
  unitSellingPrice: number | null;
  vatPercentage: number | null;
}

// Ce que cam-ag-grid-editabled lit d'une ligne ; le type distingue chapitres et commentaires.
export interface EditabledGridRow {
  id: string;
  rowType?: number;
}

export const gridRowProps: (keyof GridRow)[] = [
  'compositionPath',
  'description',
  'exclVatTotal',
  'hasChildren',
  'hidden',
  'id',
  'index',
  'order',
  'parentId',
  'quantity',
  'rowType',
  'unit',
  'unitCostPrice',
  'unitSellingPrice',
  'vatPercentage',
];

export interface GridAffectedRowResponse<T extends GridRow = GridRow> {
  modifiedProperties: string[];
  row: T;
}

export interface RowError {
  cell: string;
  error: string;
  rowId: string;
}

export interface AddGridRowResponse<T extends GridRow = GridRow> {
  addedRow: T;
  affectedRows: GridAffectedRowResponse<T>[];
}

export interface UpdateGridRowsResponse<T extends GridRow = GridRow> {
  affectedRows: GridAffectedRowResponse<T>[];
  errors: RowError[];
}

export interface DeleteGridRowsResponse<T extends GridRow = GridRow> {
  affectedRows: GridAffectedRowResponse<T>[];
  deletedIds: string[];
}

export interface ConvertGridLineResponse<T extends GridRow = GridRow> {
  affectedRows: GridAffectedRowResponse<T>[];
  convertedRow: T;
  errors: RowError[];
}

export interface MoveGridRowResponse<T extends GridRow = GridRow> {
  affectedRows: GridAffectedRowResponse<T>[];
  movedRow: T;
}

export interface DuplicateGridRowResponse<T extends GridRow = GridRow> {
  addedRows: T[];
  affectedRows: GridAffectedRowResponse<T>[];
}
